import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ReportService} from '../shared/services/report.service';

@Component({
    selector: 'app-report',
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {
    coordinators;
    reports: any[] = [];
    array = [];
    sum = 100;
    throttle = 300;
    scrollDistance = 1;
    scrollUpDistance = 2;
    direction = '';
    modalOpen = false;

    constructor(private route: ActivatedRoute, public reportService: ReportService) {
    }

    ngOnInit() {
        this.coordinators = this.route.snapshot.data.roles.filter(role => role.accessLevel === 'Regular');
        this.reports = this.route.snapshot.data.reports;
        this.appendItems(0, this.sum);
    }

    onDelete(reportId) {
        this.reportService.deleteReport(reportId);
    }

    addItems(startIndex, endIndex, _method) {
        for (let i = 0; i < this.sum; ++i) {
            this.array[_method]([i, ' ', this.generateWord()].join(''));
        }
    }

    appendItems(startIndex, endIndex) {
        this.addItems(startIndex, endIndex, 'push');
    }

    prependItems(startIndex, endIndex) {
        this.addItems(startIndex, endIndex, 'unshift');
    }

    onScrollDown(ev) {
        console.log('scrolled down!!', ev);

        // add another 20 items
        const start = this.sum;
        this.sum += 20;
        this.appendItems(start, this.sum);

        this.direction = 'down';
    }

    onUp(ev) {
        console.log('scrolled up!', ev);
        const start = this.sum;
        this.sum += 20;
        this.prependItems(start, this.sum);

        this.direction = 'up';
    }

    generateWord() {
        console.log('word');
        // return chance.word();
    }

    toggleModal() {
        this.modalOpen = !this.modalOpen;
    }
}
